<template>
  <div
    v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.DELETE)"
    :class="{'spl-modal-holder-show': isVisible}"
    class="spl-modal-holder spl-modal-deactivate-event"
    @click.self="closeModal">
    <div class="spl-modal">
      <div class="spl-modal__label">
        Deactivate Event
      </div>
      <div class="row spl-modal-deactivate-event__selection">
        <div class="col6 spl-modal-deactivate-event__left-side">
          <p>Deactivate the current event of each selected parcel. Please note that some events cannot be deactivated.</p>
          <form-button :disabled="actionInProgress" @onClick="onDeactivateCurrentEvent">
            Deactivate Current Event
          </form-button>
        </div>
        <div class="col6 spl-modal-deactivate-event__right-side">
          <p>Select the event type needed to deactivate. </p>
          <p>The event type will be deactivated if found in the selected parcels event history. </p>
          <p>It is not necessary that the parcels current event is affected.</p>
          <form-label>Specific Event</form-label>
          <form-filtered-select
            ref="specificEvent"
            v-model="selectedEvent"
            :options="eventInfoOptions"
            track-by="value"
            label="label"
            placeholder="Event" />
          <form-button :disabled="selectedEvent === -1 || actionInProgress" @onClick="submitModal">
            Deactivate Specific Event
          </form-button>
        </div>
      </div>
      <div class="spl-modal__close" @click="closeModal" />
      <form-button
        :wide="true"
        :secondary="true"
        class="spl-modal-deactivate-event__close"
        @onClick="closeModal">
        Cancel
      </form-button>
    </div>
  </div>
</template>

<script lang="ts">
import webApi from '@/webApi'
import constants from '@/constants'
import Helpers from '@/helpers.vue'
import { mapState } from 'vuex'
export default {
  mixins: [Helpers],
  data () {
    return {
      isVisible: false,
      parcelIDs: [],
      selectedEvent: -1,
      actionInProgress: false,
      constants
    }
  },
  computed: {
    ...mapState('eventInfo', ['eventInfoOptions']),
    descriptionValid () {
      return this.description.length < 1
    }
  },
  mounted () {
    // Modal was opened
    window.bus.$on('openDeactivateEventModal', this.handleOpenDeactivateEventModal)
  },
  beforeDestroy () {
    window.bus.$off('openDeactivateEventModal', this.handleOpenDeactivateEventModal)
  },
  methods: {
    handleOpenDeactivateEventModal (parcelIDs) {
      this.parcelIDs = parcelIDs
      this.isVisible = true
    },
    onDeactivateCurrentEvent () {
      if (this.parcelIDs && this.parcelIDs.length > 0) {
        this.actionInProgress = true
        webApi.event.deactivate_Current_Event_By_Parcel_ID_List(this.parcelIDs)
          .then(() => {
            this.$emit('eventsDeactivated')
            this.closeModal()
          })
          .catch(() => {
            this.closeModal()
            this.$toast('Not sucessfull deactivating events', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'center',
              mode: 'override',
              className: ['spl-error-toast']
            })
          })
      }
    },
    updateSelectedEvent (value) {
      this.selectedEvent = value
    },
    submitModal () {
      if (this.parcelIDs && this.parcelIDs.length > 0 && this.selectedEvent !== -1) {
        this.actionInProgress = true
        webApi.event.deactivate_Event_By_Event_Info_ID_and_Parcel_ID_List(this.selectedEvent, this.parcelIDs).then(() => {
          this.$emit('eventsDeactivated')
          this.closeModal()
        }).catch(() => {
          this.closeModal()
          this.$toast('Not sucessfull deactivating events', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'center',
            mode: 'override',
            className: ['spl-error-toast']
          })
        })
      }
    },
    // Close the scan window
    closeModal () {
      this.selectedEvent = -1
      this.actionInProgress = false
      this.$refs.specificEvent.reset()
      this.parcelIDs = []
      this.isVisible = false
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';
    .spl-modal-deactivate-event {
      & .spl-modal {
        overflow: hidden;
      }
      &__left-side {
        border-right: 1px solid $grey_80;
        height: 300px;
        & .spl-button {
          width: 100%;
        }
      }

      &__right-side {
        height: 300px;
        & .spl-button {
          width: 100%;
          margin-top: 15px;
        }
      }

      &__close {
        margin-top: 30px;
      }
    }
</style>
